module.exports = __webpack_public_path__ + "static/media/05.c38cbdc5.jpg";